
export enum CacheKeys {
    LOGGED_IN_USER,
    LOGGED_IN_USERS_OFFER,
    OFFERS_BY_PROFESSION_AUTHENTICATED,
    OFFERS_BY_PROFESSION_UNAUTHENTICATED,
    REFERRALS_FROM_USER,
    REFERRALS_TO_USER,
    REFERRAL_BY_ID,
    REFERRAL_CONVERSATION,
    ADMIN_REFERRALS_GROUP_ONE,
    ADMIN_REFERRALS_GROUP_TWO,
    ADMIN_REFERRAL_BY_ID,
    ADMIN_REFERRAL_CONVERSATION,
    ADMIN_ACTIVITY
  }

  export const isDataEmpty = (str: string | null | undefined): boolean => {
    return str === null || str === undefined || str.trim() === '';
  };
  
  // export interface User_Info {
  //   givenName: string;
  //   familyName: string;
  //   profession: string;
  //   companyName: string | null;
  //   email: string;
  // }
  
  export interface User_WithoutId {    
    id?: string;
    givenName: string;
    familyName: string;
    profession: string;
    companyName?: string;
    groupId?: string;
    hasAgreedTsAndCs?: string;
    isMe: Boolean;
    email: string;
    companyAdmin: Boolean;
  }
  
  export interface UserAttributes {
    id: string;
    givenName: string;
    familyName: string;
    profession: string;
    companyName?: string;
    hasAgreedTsAndCs?: string;
    email: string;
    companyAdmin: Boolean;
  }
    
  export interface UserCreationAsPropertyProfessionalAttributes {   
    givenName: string;
    familyName: string;
    profession: string;
    companyName?: string;
    email: string;
  }  

  export interface UserCreationAsBusinessOwnerAttributes {   
    givenName: string;
    familyName: string;
    profession: string;
    companyName: string;
    email: string;
    theOffer: string;
    location: string;
    offeringFixedCashAmount: number;
    companyAdmin: boolean;
  } 
  
  // export interface UserForcedCreationAttributes extends UserCreationAttributes {    
  //   sendEmail: boolean;
  // }
  
  export interface OfferWithScope_UserWithoutId {
    id: number;
    theOffer?: string;
    location: string;
    offeringFixedCashAmount: number;
    startDateTime: string;
    endDateTime?: string;
    user: User_WithoutId;
  }
  
  export interface OfferAttributes {
    id: number;
    userId: string;
    theOffer?: string;
    location: string;
    offeringFixedCashAmount: number;
    startDateTime: string;
    endDateTime?: string;
  }
  
  export interface OfferWithScope extends OfferAttributes {
    user: UserAttributes;
  }
  
  export interface ReferralAttributes {
    id: number;
    offerId: number;
    theReferralDetails?: string;
    theReferralName: string;
    theReferralContact: string;
    userId: string;
    created: string;
    status: string;
    offererAlertStatus?: string | null;
    offererAlertReadAt?: string | null;
    referrerAlertStatus?: string | null;
    referrerAlertReadAt?: string | null;
    conversation: ReferralConversationSummary;
  }  

  export interface ReferralConversationSummary {
    exists: boolean;
    id: number | null;
    lastMessageId: number | null;
    lastMessageAt: string | null;
    viewerUnreadCount: number;
    viewerHasUnread: boolean;
    viewerLastReadMessageId: number | null;
    viewerLastReadAt: string | null;
  }

  export type ReferralConversationSenderType = 'user' | 'admin' | 'system';

  export type ReferralConversationMessageKind =
    | 'text'
    | 'event_note'
    | 'reminder'
    | 'system_note';

  export type ReferralConversationEventType =
    | 'referral_created'
    | 'referral_going_ahead'
    | 'referral_succeeded'
    | 'referral_failed'
    | 'referral_already_customer'
    | 'referral_payout_collected'
    | 'referral_payout_sent'
    | null;

  export interface ReferralConversationMessage {
    id: number;
    created: string;
    senderType: ReferralConversationSenderType;
    senderUserId: string | null;
    senderLabel: string | null;
    messageKind: ReferralConversationMessageKind;
    body: string | null;
    eventType: ReferralConversationEventType;
    metadata: Record<string, unknown> | null;
  }

  export type ReferralConversationParticipantRole =
    | 'member'
    | 'referrer'
    | 'offerer'
    | 'admin';

  export type ReferralConversationViewRole = 'referrer' | 'offerer';

  export interface ReferralConversationParticipant {
    userId: string;
    participantRole: ReferralConversationParticipantRole;
    lastReadMessageId: number | null;
    lastReadAt: string | null;
    unreadCount: number;
  }

  export interface ReferralConversationResponse {
    conversation: ReferralConversationSummary;
    messages: ReferralConversationMessage[];
    participants: ReferralConversationParticipant[];
  }
  
  
  export interface ReferralWithScope_UserWithoutId {
    id: number;
    offerId: number;
    theReferralDetails?: string;
    theReferralName: string;
    theReferralContact: string;
    created: string;
    status: string;
    offererAlertStatus?: string | null;
    offererAlertReadAt?: string | null;
    referrerAlertStatus?: string | null;
    referrerAlertReadAt?: string | null;
    conversation: ReferralConversationSummary;
    offer: OfferWithScope_UserWithoutId;
    user: User_WithoutId;
  }  
  
  export interface ReferralWithScope extends ReferralAttributes {
    user: UserAttributes;
    offer: OfferWithScope;
  }  

  export interface ReferralDeleteResponse {
    referralId: number;
    deleted: boolean;
    counts: {
      referrals: number;
      conversations: number;
      conversationMessages: number;
      conversationParticipants: number;
      outboundMessages: number;
      activityLogs: number;
    };
  }

  export interface AdminActivityUserSummary {
    id: string;
    givenName: string;
    familyName: string;
    email: string;
    companyName: string;
    groupId: string;
    systemAdmin: boolean;
  }

  export interface AdminActivityRecord {
    kind: 'request' | 'domain';
    id: number;
    created: string;
    userId?: string;
    actorUserId?: string;
    groupId: string;
    eventType: string;
    requestMethod?: string;
    requestPath?: string;
    entityType?: string;
    entityId?: string;
    summary?: string;
    sessionStartReason?: string | null;
    user?: AdminActivityUserSummary;
    actorUser?: AdminActivityUserSummary;
    targetUser?: AdminActivityUserSummary | null;
  }

  export interface ReferralCreationAttributes_FromUser{
 
    offerId: number;
    theReferralDetails?: string;
    theReferralName: string;
    theReferralContact: string;  
    customerConsent: boolean;
  }    

  export interface ReferralCreationRequest {
    offerId: number;
    theReferralDetails?: string;
    theReferralName: string;
    theReferralContact: string;
  }
  
  export interface OfferCreationAttributes_FromUser { 
    theOffer?: string;
    location: string;
    offeringFixedCashAmount: number;
  }
  
  
